

exports.__esModule = true;
exports.$xoShowMoreFiLink = undefined;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

require('xo-ui-components/src/link/directive');

var _factory = require('./factory');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShowMoreFiLink = exports.$xoShowMoreFiLink = _squid.$Component.extend('$xoShowMoreFiLink', {
    tag: 'xo-show-more-fi-link',
    template: _template2['default'],
    actions: {
        showMore: function showMore() {
            _factory.$ShowMoreFiFactory.set({ isShowMoreBtnClicked: true });
            _logger.$logger.info('checkout_fpti', {
                from: '3fi',
                to: 'process_3fi'
            });
        }
    },
    lifecycle: {
        enter: function enter() {}
    }
});

angular.value("$xoShowMoreFiLink", $xoShowMoreFiLink);
_squid.$Component;

_logger.$logger;

_factory.$ShowMoreFiFactory;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/show-more-fi/directive.js
// module id = ../node_modules/xo-member-components/src/show-more-fi/directive.js
// module chunks = 0